import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SAVE_AND_ENABLE_CHECKBOX: `${cleanedFilename(
    __filename,
  )}-save-and-enable-checkbox`,
};
